import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { AREAS, LOCATIONS } from "../../lib/site";
import { Reveal, Overline } from "./Reveal";

export default function AreasMarquee() {
  return (
    <section id="areas" className="relative bg-warm-white pb-24 md:pb-36" aria-labelledby="areas-heading">
      {/* Teal keyword marquee band */}
      <div className="bg-ocean-teal py-6 overflow-hidden">
        <Marquee speed={38} gradient={false}>
          {AREAS.concat(AREAS).map((a, i) => (
            <span key={i} className="flex items-center">
              <span className="font-serif font-light text-warm-white text-3xl sm:text-4xl px-8">
                Cleaning Services in {a}
              </span>
              <span className="text-antique-gold text-2xl">✦</span>
            </span>
          ))}
        </Marquee>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mt-16 md:mt-20">
        <div className="max-w-3xl">
          <Reveal><Overline>Service Areas — Based in Jervis Bay, Australia</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 id="areas-heading" className="mt-6 font-serif font-light text-4xl sm:text-5xl text-charcoal leading-[1.1]">
              Luxury Cleaning Services in Jervis Bay, Sydney, Adelaide, Townsville &amp; Airlie Beach
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 font-sans font-light text-base md:text-lg text-charcoal/70 leading-relaxed">
              Casa Galênê Cleaning provides boutique residential, commercial, holiday-home and
              post-construction cleaning across five of Australia&apos;s most sought-after locations.
              Wherever you are, expect the same five-star, hospitality-inspired attention to detail —
              with future expansion planned across the country.
            </p>
          </Reveal>
        </div>

        {/* Location cards */}
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {LOCATIONS.map((loc, i) => (
            <Reveal key={loc.name} delay={i * 0.08}>
              <article
                data-testid={`location-card-${loc.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="group relative h-[420px] overflow-hidden rounded-sm shadow-[0_20px_50px_-25px_rgba(10,75,84,0.35)]"
              >
                <motion.img
                  src={loc.img}
                  alt={`Luxury cleaning services in ${loc.name}, ${loc.region}`}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ocean-teal/90 via-ocean-teal/30 to-transparent" />
                <div className="relative z-10 h-full flex flex-col justify-end p-7">
                  <span className="flex items-center gap-2 text-antique-gold text-xs tracking-[0.2em] uppercase">
                    <MapPin size={13} /> {loc.region}
                  </span>
                  <h3 className="mt-2 font-serif text-3xl text-warm-white">{loc.name}</h3>
                  <p className="mt-3 font-sans font-light text-sm text-warm-white/85 leading-relaxed">
                    {loc.blurb}
                  </p>
                  <span className="mt-4 font-sans text-[11px] tracking-wide text-warm-white/70">
                    {loc.keywords}
                  </span>
                  <a
                    href="#quote"
                    data-testid={`location-quote-${loc.name.toLowerCase().replace(/\s+/g, "-")}`}
                    className="mt-5 inline-flex w-fit rounded-full bg-warm-white/95 px-5 py-2.5 text-xs font-medium tracking-wide text-ocean-teal hover:bg-antique-gold hover:text-warm-white transition-colors"
                  >
                    Get a Quote in {loc.name}
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
